import { API_VERSION, HOME_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_INSPECTION_AUTHORITIES = `${HOME_SERVICE}/inspection-authorities`;

export const inspectionAuthorities = {
  getAll: async ({ filters, sort, params, signal, top, skip } = {}) => {
    const options = await apiOptions({
      url: API_INSPECTION_AUTHORITIES,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
      params,
      filters,
      sort,
      top,
      skip,
    });
    return apiRequest(options);
  },
  getByType: async ({ type }) => {
    const options = await apiOptions({
      url: `${API_INSPECTION_AUTHORITIES}/types/${type}`,
      header: { [X_API_VERSION]: API_VERSION },
      method: "get",
    });
    return apiRequest(options);
  },
  getById: async ({ id, signal } = {}) => {
    const options = await apiOptions({
      url: `${API_INSPECTION_AUTHORITIES}/${id}`,
      method: "get",
      headers: { [X_API_VERSION]: API_VERSION },
      signal,
    });
    return apiRequest(options);
  },
  create: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: API_INSPECTION_AUTHORITIES,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_INSPECTION_AUTHORITIES}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data: { ...data },
    });
    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, modifiedOn, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_INSPECTION_AUTHORITIES}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data: { modifiedOn },
    });
    return apiRequest(options, toastMessageConfig);
  },
};
